export const
      PAUSES_REQUEST = 'PAUSES_REQUEST',
      SAVE_PAUSES_REQUEST = 'SAVE_PAUSES_REQUEST',
      DELETE_PAUSES_REQUEST = 'DELETE_PAUSES_REQUEST',
    
      SAVE_PAUSES_PREPARE = 'SAVE_PAUSES_PREPARE',
      DELETE_PAUSES_PREPARE = 'DELETE_PAUSES_PREPARE',
    
      RECEIVE_UPDATED_PAUSE = 'RECEIVE_UPDATED_PAUSE',
      RECEIVE_DELETED_PAUSE = 'RECEIVE_DELETED_PAUSE'
